import { render, staticRenderFns } from "./title-line.vue?vue&type=template&id=54e2c5ae&scoped=true"
import script from "./title-line.vue?vue&type=script&lang=js"
export * from "./title-line.vue?vue&type=script&lang=js"
import style0 from "./title-line.vue?vue&type=style&index=0&id=54e2c5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2c5ae",
  null
  
)

export default component.exports